import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { css } from "styled-components";

logoStyles.container = {
    css: css`
        width: 100%;
        margin: 50px 0;
        text-align: center;
    `,
};

logoStyles.image = {
    css: css`
        width: 300px;
        height: 300px;
    `,
};
